import { render } from "./App.vue?vue&type=template&id=e6933880"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e6933880&lang=less"

import exportComponent from "/Users/jinzhouhang/work/zhanhai/beautifuldai-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__